module.exports = __webpack_public_path__ + "images/emoji/bangbang.ccc4eb97c25da018b1dd.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/bangbang.png
// module id = /BuN
// module chunks = 13